import { render } from "./ManualChecks.vue?vue&type=template&id=1a16af3f"
import script from "./ManualChecks.vue?vue&type=script&lang=js"
export * from "./ManualChecks.vue?vue&type=script&lang=js"

import "./ManualChecks.vue?vue&type=style&index=0&id=1a16af3f&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__